import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import Top from "../organisms/home/Top"
import Map from "../organisms/home/Map"
import Vision from "../organisms/home/Vision"
import ContentsCard from "../organisms/home/ContentsCards"

export default class Home extends Component {
  render() {
    return (
      <>
        <Top />
        <Vision />
        <ContentsCard />
        <Map />
      </>
    )
  }
}
